const version = "/v1";

export const methodType = {
  PUT: "put",
  GET: "get",
  POST: "post",
  DELETE: "delete",
  PATCH: "patch",
};

export const apiEndPoints = {
  authSignup: "/v1/auth/signup/",
  authLogin: "/v1/auth/login/",
  authLogout: "/v1/auth/logout/",
  authVerifyMail: "/v1/auth/verify-mail/",
  authChangePassword: "/v1/auth/change-password/",
  resendEmailOtp: "/v1/auth/resend-email-otp/",
  verifyPhone: "/v1/auth/verify-phone/",
  resendOTP: "/v1/auth/resend-otp/",
  verifyPasswordReset: "/v1/auth/verify-password-reset/",
  resetPassword: "/v1/auth/reset-password/",
  unsubscribeEmail: "/v1/auth/unsubscribe/",
  applicationStatus: "/v1/loan/status",
  kycPersonal: "/v1/kyc/personal-kyc",
  kycBusiness: "/v1/kyc/business-kyc",
  kycStatus: "/v1/kyc/status",
  authCities: "/v1/reference/cities",
  getBanks: "/v1/reference/banks",
  authOccupation: "/v1/reference/occupation",
  authNationality: "/v1/reference/nationality",
  authIndustrySector: "/v1/reference/industry-sector",
  getUserBusinessKyc: "/v1/kyc/business-kyc/",
  updateUserKyc: "/v1/auth/user/",
  getBusiness: "/v1/auth/business",

  // applications
  applicationsList: 'v1/loan/applications',
  applicationStatusDetails: (applicationId) => `/v1/loan/applications/${applicationId}/status`,

  // loan
  createLoan: "/v1/loan/loan",
  createAdditionalLoan: "/v1/loan/additional",
  evaluation: "/v1/loan/credit-evaluation",
  settlementBankAcount: "/v1/loan/settlement-bank-account",
  validateIban: "/v1/gib/validate-iban",
  // Integrations
  fetchIntegrations: "/v1/integrations",
  connectAmazon: "/v1/integrations/amazon-connect",
  // agreements
  agreements: "/v1/agreements/",
  // Dynamic endpoint with loanId
  agreementStatus: (agreementId) => `/v1/agreements/${agreementId}/status`,
  virtualAccount: (loanId) => `/v1/loan/${loanId}/virtual-accounts`,
  virtualAccountDocument: (loanId, vaId) => `/v1/loan/${loanId}/virtual-accounts/${vaId}/documents`,

  fetchLMSDashboardUrl: "/v1/lms/lms-dashboard-token",

  // reference
  businessTypeList: `/v1/reference/business-types`,
  industrySectorsList: `/v1/reference/industry-sector`,
  nationalityList: "/v1/reference/nationality",
  cityList: "/v1/reference/cities",
  businessSegmentsList: "/v1/reference/business-segments",

  // documents
  documentsList: `/v1/documents/`,
  documentTypesList: `/v1/documents/application-document-types`,
  documents: "/v1/documents/",
  eachDocument: (documentId) => `/v1/documents/${documentId}/`,
  documentFiles: (documentId) => `/v1/documents/${documentId}/files/`,
  deleteFile: (fileId) => `/v1/documents/document-files/${fileId}/`,

  // businesskyc
  getBusinessKyc: `/v1/kyc/business-kyc-v2`,
  postBusinessKYC: `/v1/kyc/business-kyc-v2`,
  updateBusinessKYC: (kycId) => `/v1/kyc/business-kyc-v2/${kycId}`,

  // shareholders
  shareholdersList: `/v1/kyc/shareholder`,
  shareholderDetails: (shareholderId) => `/v1/kyc/shareholder/${shareholderId}`,
  editShareholder: (shareholderId) => `/v1/kyc/shareholder/${shareholderId}`,
  deleteShareholder: (shareholderId) => `/v1/kyc/shareholder/${shareholderId}`,
  createShareholder: `/v1/kyc/shareholder`,
  shareholdingCoverage: `/v1/kyc/shareholder/coverage`,

  // personal KYC
  getPersonalKyc: `/v1/kyc/personal-kyc-v2`,
  personalKYCDetails: (shareholderId) => `/v1/kyc/shareholder/${shareholderId}/user-kyc`,
  postPersonalKYC: `/v1/kyc/personal-kyc-v2`,
  patchPersonalKYC: (kycId) => `/v1/kyc/personal-kyc-v2/${kycId}`,

  //support tickets
  supportTickets: "/v1/support/tickets/",
  supportTicketDetails: (ticketId) => `/v1/support/tickets/${ticketId}/`,
  supportTicketSummary: `/v1/support/tickets/summary/`,

  // RBF LMS APIs
  loanSummary: "/v1/rbf/loan-summary/",
  repaymentSchedule: "/v1/rbf/repayment-schedule/",
  transactions: "/v1/rbf/loan-transactions",

  // Reports
  getStatementEntries: "/v1/rbf/reports/statement/entries/",
  statementReport: "/v1/rbf/reports/statement/",
  repaymentScheduleReport: "/v1/rbf/reports/repayment-schedule/",
  statementOfAccount: (loanUUID) => `/v1/loan/${loanUUID}/statement-of-account`,

};

export default apiEndPoints;
